<router-outlet />
<meta-loading />
@if (chatService.$chatShown()) {
    <meta-chat @inOutPaneAnimation [course]="chatService.$currentCourse()" [isGlobal]="chatService.$isGlobal()"
        (doClose)="chatService.toggleChat$.emit(false)" />
}
@if ($showPrivacyDisclaimer()) {
    <meta-popup [config]="privacyDisclaimerConfig" [bodyTemplateRef]="privacyDisclaimer">
        <ng-template #privacyDisclaimer>
            <meta-privacy-policy [onlyContent]="true" />
        </ng-template>
    </meta-popup>
}